import React, { useEffect, useState } from 'react';
import SnackItem from './SnackItem';
import CartModal from './CartModal';
import { groupItemsByCategory } from '../utils/categories';
import { useOrderManager } from './OrderManager';

const SnacksList = ({ snacks, searchQuery }) => {
  const [groupedSnacks, setGroupedSnacks] = useState({});
  const [filteredSnacks, setFilteredSnacks] = useState([]);
  const [showCartModal, setShowCartModal] = useState(false);
  
  // Use the OrderManager context to handle order processing
  const { 
    isLoading, 
    setIsLoading, // Add setIsLoading from context
    handlePlaceOrder
  } = useOrderManager();
  
  // Filter and group snacks when snacks or search query changes
  useEffect(() => {
    // Filter snacks based on search query
    const filtered = snacks.filter(snack => 
      snack.Description.toLowerCase().includes(searchQuery.toLowerCase())
    );
    
    setFilteredSnacks(filtered);
    
    // Group filtered snacks by category
    const grouped = groupItemsByCategory(filtered);
    setGroupedSnacks(grouped);
  }, [snacks, searchQuery]);

  const handleItemAdded = () => {
    setShowCartModal(true);
  };

  const handleCloseCartModal = () => {
    setShowCartModal(false);
  };

  // Handle checkout process using the OrderManager
  const handleCheckout = async () => {
    // Show loading state in the cart modal but don't close it yet
    setIsLoading(true);
    
    // Place the order - the cart modal will stay open with a loading indicator
    // Only after the order is successfully placed will we close it
    const success = await handlePlaceOrder(() => {
      // This callback runs after the order is successfully placed
      // Now we can safely close the cart modal
      setShowCartModal(false);
    });
    
    // If order placement failed, stop the loading state
    if (!success) {
      setIsLoading(false);
    }
  };

  // Render the list of snacks
  const renderSnacksList = () => {
    if (filteredSnacks.length === 0) {
      return (
        <div className="no-results">
          <p>No snacks found matching "{searchQuery}"</p>
        </div>
      );
    }
    
    if (searchQuery.length > 0) {
      // Show ungrouped view when searching
      return (
        <div className="snacks-grid">
          {filteredSnacks.map(snack => (
            <SnackItem key={snack.Id} item={snack} onItemAdded={handleItemAdded} />
          ))}
        </div>
      );
    } else {
      // Show grouped view
      return Object.entries(groupedSnacks).map(([category, items]) => {
        if (items.length === 0) return null;
        
        return (
          <div key={category} className="category-section">
            <h2 className="category-title">{category}</h2>
            <div className="snacks-grid">
              {items.map(snack => (
                <SnackItem key={snack.Id} item={snack} onItemAdded={handleItemAdded} />
              ))}
            </div>
          </div>
        );
      });
    }
  };

  return (
    <div className="snacks-container">      
      {renderSnacksList()}
      
      <CartModal 
        isOpen={showCartModal} 
        onClose={handleCloseCartModal}
        onCheckout={handleCheckout}
        isLoading={isLoading}
      />
    </div>
  );
};

export default SnacksList;
